module.exports = __webpack_public_path__ + "static/img/sc-null.1e63807.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sc-null.png
// module id = YX5o
// module chunks = 1